export default __webpack_public_path__ + "static/media/corprateOn.fce7e8ed.svg";